import React from 'react';
import { Fade, Roll, Zoom } from 'react-reveal';

import resume from '../assets/img/pdf/MD-NAHID-RESUME.pdf';
import Shake from 'react-reveal/Shake';
import Typed from 'react-typed';

const Hero = () => {
  return (
    <section
      id='home'
      className='lg:h-[100vh] flex items-center bg-primary lg:bg-cover -mb-44 md:-mb-0 lg:bg-center lg:bg-no-repeat py-32 lg:py-0 overflow-hidden'
    >
      <div className='container mx-auto h-full'>

        <div className='flex flex-col md:flex-row gap-2 items-center h-full pt-8'>
          <div className='flex-1 flex flex-col items-center lg:items-start'>

            <Roll left>
              <p className='text-xl md:text-2xl lg:text-3xl text-accent pt-10 text-md mb-[22px] flex'>
                Hey, I'm MD. NAHID! <Shake>👋</Shake>
              </p>
            </Roll>
            <Fade left>
              <div className='text-3xl text-white leading-[44px] md:text-4xl md:leading-tight lg:text-5xl lg:leading-[1.2] font-bold md:tracking-[-2px]'>
                I Am&nbsp;
                <span className="text-accent">
                  <Typed
                    strings={[
                      'Web Designer',
                      'Web Developer']}
                    typeSpeed={40}
                    backSpeed={50}
                    loop >
                  </Typed>
                </span>
              </div>
            </Fade>
            <Fade right>
              <p className='pt-4 pb-8 md:pt-6 md:pb-12 max-w-[480px] text-lg text-center lg:text-left'>
                I specialize in crafting responsive, user-focused websites. As a dedicated and detail-oriented developer, I&apos;m committed to bringing creativity, punctuality, and a positive attitude to each project.
              </p>
              <a href={resume} download>
                <Zoom top duration={1500}>
                  <button className='btn btn-md bg-accent hover:bg-secondary-hover md:btn-lg transition-all'>
                    Download My Resume
                  </button>
                </Zoom>
              </a>
            </Fade>
          </div>
          <Zoom left duration={2000}>
            <div className='flex flex-1 justify-end items-end h-full p-2 md:p-0'>
              <img className='object-cover h-full p-10 md:p-0' src={`https://res.cloudinary.com/dsigyjfjq/image/upload/fl_preserve_transparency/v1741697633/nhd_2_ptxsbl.jpg`} alt='developer nahid' />
            </div>
          </Zoom>
        </div>
      </div>
    </section>
  );
};

export default Hero;
